import { Grid } from '@/common/grid/Grid';
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';


export const IncListCompareDialog = ({ data, closeDialog }) => {
  const leftGridRef = useRef();
  const rightGridRef = useRef();
  const [fieldDefs, setFieldDefs] = useState();
  const [isLeftGridReady, setIsLeftGridReady] = useState(false);
  const [isRightGridReady, setIsRightGridReady] = useState(false);

  const [title0, title1, value0, value1] = [data.title0, data.title1, data.value0, data.value1];
  const items0 = value0.split(',').map(s => s.trim());
  const items1 = value1.split(',').map(s => s.trim());

  const [leftFilter, setLeftFilter] = useState('all'); // 'all', 'left', 'both'
  const [rightFilter, setRightFilter] = useState('all'); // 'all', 'right', 'both'

  // Compute filtered rows based on filter
  let leftRows = items0;
  let rightRows = items1;

  if (leftFilter === 'both' && rightFilter === 'both') {
    leftRows = items0.filter(item => items1.includes(item));
    rightRows = items1.filter(item => items0.includes(item));
  } else {
    if (leftFilter === 'left') {
      leftRows = items0.filter(item => !items1.includes(item));
    }
    if (rightFilter === 'right') {
      rightRows = items1.filter(item => !items0.includes(item));
    }
  }

  leftRows = leftRows.map(item => ({
    item,
    onOppositeRow: items1.includes(item)
  }));
  rightRows = rightRows.map(item => ({
    item,
    onOppositeRow: items0.includes(item)
  }));

  useEffect(() => {
    const fieldDefs = [
      { field: 'item' },
      { field: 'onOppositeRow', displayName: '', type: 'BOOLEAN', maxWidth: 50 },
    ];
    setFieldDefs(fieldDefs);
  }, []);

  useEffect(() => {
    if (isLeftGridReady && leftGridRef.current) {
      leftGridRef.current.setDataSource(leftRows);
    }
  }, [isLeftGridReady, leftRows]);

  useEffect(() => {
    if (isRightGridReady && rightGridRef.current) {
      rightGridRef.current.setDataSource(rightRows);
    }
  }, [isRightGridReady, rightRows]);

  function compareListGridBox({ title, gridRef, onGridReady }) {
    return (
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          maxWidth: '50%',
          display: 'flex',
          flexDirection: 'column',
          height: '40vh',
          gap: 1,
        }}
      >
        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 700 }}>{title}</Typography>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
          }}
        >
          <Grid
            ref={gridRef}
            gridOptions={{
              fieldDefs: fieldDefs,
              rowModelType: 'clientSide',
            }}
            events={{onGridReady}}
          />
        </Box>
      </Box>
    );
  }

  // Button handlers
  const handleLeftOnly = () => {    
    if (leftFilter === 'left') {
      setLeftFilter('all');
      return;
    } else if (leftFilter === 'both') {
      setRightFilter('all');
    }
    setLeftFilter('left');
  };

  const handleRightOnly = () => {
    if (rightFilter === 'right') {
      setRightFilter('all');
      return;
    } else if (rightFilter === 'both') {
      setLeftFilter('all');
    }
    
    setRightFilter('right');
  };
  
  const handleBoth = () => {
    if (leftFilter === 'both' && rightFilter === 'both') {
      setLeftFilter('all');
      setRightFilter('all');
    } else {
      setLeftFilter('both');
      setRightFilter('both');
    }
  };

  const clickedStyle = { backgroundColor: '#9ad0b2', color: 'black', border: '1.5px solid black' };

  return (
    <Dialog onClose={closeDialog} open fullWidth maxWidth="l"
      slotProps={{
        paper: {
          sx: {
            maxHeight: '80vh',
            width: '80%',
            maxWidth: '80%',
            display: 'flex',
            flexDirection: 'column',
          }
        }
      }}>
      <DialogTitle>
        <Typography variant="h5">Compare Inclusion Lists</Typography>
      </DialogTitle>

      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginY: 2,
          gap: 0,
          alignItems: 'stretch',
          justifyContent: 'center',
          overflow: 'visible',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 4, alignItems: 'stretch', justifyContent: 'center', flex: 1 }}>
          {compareListGridBox({
            title: title0,
            gridRef: leftGridRef,
            onGridReady: () => setIsLeftGridReady(true),
          })}
          {compareListGridBox({
            title: title1,
            gridRef: rightGridRef,
            onGridReady: () => setIsRightGridReady(true),
          })}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, py: 2, borderTop: '1px solid #eee', mt: 2 }}>
          <Button
            style={leftFilter === 'left' ? clickedStyle : {}}
            onClick={handleLeftOnly}
          >
            Left only
          </Button>
          <Button
            style={leftFilter === 'both' && rightFilter === 'both' ? clickedStyle : {}}
            onClick={handleBoth}
          >
            Both
          </Button>
          <Button
            style={rightFilter === 'right' ? clickedStyle : {}}
            onClick={handleRightOnly}
          >
            Right only
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
